import React, { useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { throttle } from "lodash";
import Paper from "@mui/material/Paper";
import moment from "moment";
import { Button, Typography } from "@mui/material";
import { downloadSampleExcelFile } from "../../../helper/utils";
import { NotificationActions } from "../../../redux/slices/componentSlice/notificationSlice";
import focusSkuApi from "../../../services/apiService/api/focusSkuApi";
import "../style.scss";
import { downloadSampleExcelFromBlob } from "../../../helper/utils";

export default function HistoryTable(props) {
  const dispatch = useDispatch();
  const { refresh, selector, thunk, type, onDownload } = props;
  const {
    historyData = {},
    historyDataLoading = false,
    historyDataError = null,
    historyDataPrevLoading = false,
  } = selector || {};
  const [historyAllData, setHistoryAllData] = useState([]);
  const [page, setPage] = useState(0);
  const { totalPages } = historyData;
  
  useEffect(() => {
    // Always use the content from historyData since it now contains all accumulated data
    setHistoryAllData(historyData?.content || []);
  }, [historyData]);

  useEffect(() => {
    // On first load or when refresh/page changes, set data directly
    if (!historyDataLoading && !historyDataPrevLoading && !historyDataError && page === 0) {
      setHistoryAllData(historyData?.content || []);
    }
  }, [historyData, historyDataLoading, historyDataError, historyDataPrevLoading, page]);

  useEffect(() => {
    setHistoryAllData([]);
    setPage(0);
    if (thunk) {
      dispatch(thunk({ page: 0 }));
    }
  }, [refresh]);

  useEffect(() => {
    if (page !== 0) {
      if (thunk) {
        dispatch(thunk({ page: page }));
      }
    }
  }, [page]);

  const fetchMoreData = (page, totalPages) => {
    if (totalPages > page) {
      setPage(page++);
    }
  };

  const handleThrottle = useCallback(
    throttle((e, totalPages) => fetchMoreData(e, totalPages), 2000),
    []
  );

  const handleScrolEvent = (event) => {
    let navElement = event.target;
    let soFarScrolled = navElement.scrollTop;
    let totalHeight = navElement.scrollHeight;
    const limit = 0.6;
    if (soFarScrolled / totalHeight > limit) {
      handleThrottle(page + 1, totalPages);
    }
  };

  const handleTemplateDownload = (row) => {
    onDownload(row?.requestId);
  };



  return (
    <div>
      <div onScroll={handleScrolEvent} className="history">
        {historyAllData?.map((row) => (
          <Paper
            sx={{
              border: "1px solid #D4D4D4",
              fontSize: "14px",
              padding: "12px",
              borderRadius: "8px",
              boxShadow: "none",
              fontFamily: "JioType",
              marginBottom: "12px",
            }}
            key={row.requestId || row.fileName || row.name}
          >
            <div>
                  <div className="historyContainer" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div className="headerText">{row.fileName}</div>
                    <Button
                        variant="text"
                        disabled={row.status === 'IN_PROGRESS'}
                        onClick={() => {
                          handleTemplateDownload(row);
                        }}
                      >
                        <Typography
                          sx={{
                            color: row.status === 'IN_PROGRESS' ? '#9e9e9e' : '#000093',
                            fontSize: "0.875rem",
                            textTransform: "none",
                            fontWeight: "bold",
                          }}
                        >
                          Download
                        </Typography>
                      </Button>
                  </div>
                  <div className="statusContainer" style={{display: 'flex', gap: '24px', marginTop: '8px'}}>
                    <div>
                      <div className="header">Uploaded By</div>
                      <span className="value">{row.uploadedBy}</span>
                    </div>
                    <div>
                      <div className="header">Uploaded Date</div>
                      <span className="value">{row.creationAt ? moment(row.creationAt).format("DD-MMM-YYYY h:mm A") : ''}</span>
                    </div>
                    {row.status && (
                      <div>
                        <div className="header">Status</div>
                        <span className="value" style={{
                          color: row.status === 'COMPLETED' ? 'green' : row.status === 'IN_PROGRESS' ? 'orange' : 'inherit',
                          fontWeight: 'bold',
                        }}>{row.status}</span>
                      </div>
                    )}
                  </div>
            </div>
          </Paper>
        ))}
      </div>
    </div>
  );
}

